<div class="popup">
  <div class="popup__header">
    <h4 *ngIf="title" class="popup__title">{{ title }}</h4>
    <button (click)="close()" class="popup__close" mat-icon-button [attr.aria-label]="closeAriaLabel">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="popup__content">
    <ng-content></ng-content>
  </div>
</div>
